export default __webpack_public_path__ + "static/media/A4_21.5ec65776.mp3";